export default "__VITE_ASSET__CEdau52$__"